var Vehicles = (function () {

  function _deleteObject(ids) {
    return $.ajax({
      url: Url.action('api/vehicles'),
      type: 'DELETE',
      dataType: 'json',
      data: { ids: ids }
    })
    .done(() => {
      _refreshTable(true, ids);
    });
  };

  function _delete(ids) {
    if (ids.length > 0 && confirm('Вы действительно хотите удалить {0} записей?'.format(ids.length))) {
      _deleteObject(ids);
    }
  };

  function _show(id) {
    var modal = ModalConductor.activate(VehicleViewModal, id,
     (vehicleId) => {
       _deleteObject([vehicleId]).done(() => {
         modal.close();
       });
     },
    (vehicleId) => {
      _showOnMap([vehicleId]);
    })
     .on('closed', (modalResult) => {
       _refreshTable();
     });
  }

    function _refreshTable(resetChecked, rowsForDeselect) {
        var table = $('#VehicleListItemTable').DataTable();
        refreshTable(table, resetChecked, null, rowsForDeselect);
    };

  function _add() {
    ModalConductor.activate(VehicleEditModal).on('closed', (modalResult) => {
      if (modalResult.ok)
        _refreshTable();
    });
  }

  function _showOnMap(ids) {
    if (ids.length > 0) {
      location.href = Url.map(ObjectTypes.Vehicle, ids);
    }
  }

  function _init() {

    $(document)
      .on('click', 'td.show-track-td', function (e) {

        var table = $('#VehicleListItemTable').DataTable();
        var row = table.row($(this).parent()).data();
        var id = row.Id;

        ModalConductor.activate(VehicleTrackModal, id);
      });
  }

  return {
    init: _init,
    show: _show,
    add: _add,
    deleteObjects: _delete,
    showOnMap: _showOnMap
  };
}());
